module.exports = __webpack_public_path__ + "static/media/assa-star-icon.e9781afd.svg";